import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ResponsiveModal from '@components/ResponsiveModal';
import Buttons from './components/Buttons';
import Texts from './components/Texts';
import Image from './components/Image';

const ModalContainer = styled.div`
  text-align: center;
  width: 90%;
  max-height: 85vh;
  overflow: auto;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-height: 85vh;
  overflow: auto;
  padding: 0px;
  border-radius: 6px;

  & h2 {
    margin: 0;
    font-size: 1.4em;
  }
`;

const ChildrenContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

function Modal({
  open,
  title,
  message,
  cancelLabel,
  acceptLabel,
  onClose,
  onAccept,
  icon,
  closeOnOutsideClick,
  children,
  footer,
  header,
  hideOptions = false,
  showCloseIcon,
  customStyle,
  imageHeight,
}) {
  const modalRef = createRef();

  return (
    <ResponsiveModal
      open={open}
      onClose={onClose}
      showCloseIcon={showCloseIcon}
      center
      closeOnEsc={closeOnOutsideClick}
      closeOnOverlayClick={closeOnOutsideClick}
      ref={modalRef}
      blockScroll={open}
    >
      {header}
      <ModalContainer>
        <ChildrenContainer id="modal__content">
          {children || (
            <>
              {!!icon && <Image src={icon} height={imageHeight} />}
              <Texts
                title={title}
                message={message}
                customStyle={customStyle}
              />
            </>
          )}
        </ChildrenContainer>
        {footer}
        <Buttons
          onClose={onClose}
          cancelLabel={cancelLabel}
          onAccept={onAccept}
          acceptLabel={acceptLabel}
          hideOptions={hideOptions}
        />
      </ModalContainer>
    </ResponsiveModal>
  );
}

Modal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  cancelLabel: PropTypes.string,
  acceptLabel: PropTypes.string,
  icon: PropTypes.string,
  closeOnOutsideClick: PropTypes.bool,
  onClose: PropTypes.func,
  onAccept: PropTypes.func,
  children: PropTypes.node,
  hideOptions: PropTypes.bool,
  showCloseIcon: PropTypes.bool,
  customStyle: PropTypes.object,
  imageHeight: PropTypes.number,
  footer: PropTypes.object,
  header: PropTypes.object,
};

Modal.defaultProps = {
  closeOnOutsideClick: true,
  imageHeight: 80,
  showCloseIcon: false,
  customStyle: {},
  header: null,
  footer: null,
};

export default Modal;
